import type { WormholeData, WormholeSystem } from '@eve-log/shared';
import type { ShallowRef } from 'vue';

// Deferred import — splits wormholes.json (335KB) into a separate chunk
// so it doesn't block initial page load.
const data = shallowRef<WormholeData>({});
const systemNames = shallowRef<string[]>([]);

import('../../data/wormholes.json').then((mod) => {
  data.value = mod.default as WormholeData;
  systemNames.value = Object.keys(data.value).sort();
});

export function useWormholes() {
  function search(query: string, limit = 20): string[] {
    if (!query) return [];
    const q = query.toUpperCase();
    return systemNames.value.filter((name) => name.toUpperCase().includes(q)).slice(0, limit);
  }

  function getSystemId(systemName: string): number | null {
    return data.value[systemName]?.systemId ?? null;
  }

  function getClass(systemName: string): number | null {
    return data.value[systemName]?.class ?? null;
  }

  function getEffect(systemName: string): string | null {
    return data.value[systemName]?.effect ?? null;
  }

  function getSystem(systemName: string): WormholeSystem | null {
    return data.value[systemName] ?? null;
  }

  return {
    data: data as Readonly<ShallowRef<WormholeData>>,
    systemNames: systemNames as Readonly<ShallowRef<string[]>>,
    search,
    getSystemId,
    getClass,
    getEffect,
    getSystem,
  };
}
